export default function Logo({ className = 'h-8 w-auto' }) {
  return <img src="/logo.svg" alt="jawabai" className={className} />;
}
